import {inject, Injectable} from '@angular/core';
import {OrderCommandService} from '../store/order/order-command.service';
import {NotifyUnpaidOrderUseCase} from '../use-cases/notify-unpaid-order.use-case';
import {CreateCartOrderUseCase} from '../use-cases/create-cart-order.use-case';
import {CartCommandService} from '../store/cart/cart-command.service';
import {Product} from '@features/sales/domain/models/product/product.model';
import {AddItemToCartUseCase} from '../use-cases/add-item-to-cart.use-case';
import {Observable} from 'rxjs';
import {SplitMode} from '@features/sales/domain/models/order/order-split.model';
import {CartItemOptions} from "@features/sales/domain/models/cart/cart-item.model";
import {Order} from '@features/sales/domain/entities/order/order.entity';

@Injectable({providedIn: 'root'})
export class SalesFacade {
  private readonly cart = inject(CartCommandService);
  private readonly order = inject(OrderCommandService);
  private readonly addItem = inject(AddItemToCartUseCase);
  private readonly notifyUnpaid = inject(NotifyUnpaidOrderUseCase);
  private readonly createOrder = inject(CreateCartOrderUseCase);

  handleCartOpened(cartId: string): void {
    this.notifyUnpaid.execute(cartId);
  }

  createOrders(mode: SplitMode): Observable<Order[]> {
    return this.createOrder.execute(mode);
  }

  addItemToCart(product: Product, quantity: number, options?: CartItemOptions): void {
    this.addItem.execute(product, quantity, options);
  }

  clearSessionCart(): void {
    this.cart.clear();
  }

  clearSessionOrders(): void {
    this.order.reset();
  }
}
